module.exports = __webpack_public_path__ + "img/web.1fe8d55f.svg";